import React, {useEffect, useState} from "react";
import {Tabs} from "antd";
import {useTranslation} from "react-i18next";
import AnnouncementListing_3 from "./component/announcementListing";
import {getUserAnnouncementByUserId} from "../../../../api/graphql/announcement";
import {
    globalNotificationState,
    globalUnreadAnnouncementCountState,
    globalUnreadPushNotificationCountState
} from "../../../../_common/global_state";
import {useSetRecoilState} from "recoil";
import "./css/style.css"
import {getPushNotificationLogByUserId} from "../../../../api/graphql/pushNotification";
import PushNotificationListing_3 from "./component/pushNotificationListing";

const Announcement_3 = (props) => {
    const {isHeader} = props
    const {t} = useTranslation();
    const setNotificationMessage = useSetRecoilState(globalNotificationState);
    const setUnreadAnnouncementCount = useSetRecoilState(globalUnreadAnnouncementCountState);
    const [announcementTotal, setAnnouncementTotal] = useState(0)
    const [announcementData, setAnnouncementData] = useState({});

    const userId = localStorage.getItem("userid")

    const preload = async () => {
        try {
            const responseAnnouncement = await getUserAnnouncementByUserId(userId, 8, 0);
            setAnnouncementData(responseAnnouncement?.getUserAnnouncementByUserId?.data);
            setUnreadAnnouncementCount(responseAnnouncement?.getUserAnnouncementByUserId?.unreadTotal);
            setAnnouncementTotal(responseAnnouncement?.getUserAnnouncementByUserId?.total);
        } catch (e) {
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the announcement page. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        }
    }

    useEffect(() => {
        preload()
    }, [])

    const items = [
        {
            key: "1",
            label: "Announcement",
            children: <AnnouncementListing_3 isHeader={isHeader} data={announcementData} total={announcementTotal}/>,
        },
        {
            key: "2",
            label: "Notification",
            children: <PushNotificationListing_3 isHeader={isHeader}/>,
        },
    ];

    return (
        <Tabs
            centered
            id={"announcement"}
            defaultActiveKey="1"
            items={items}
        />
    )
}

export default Announcement_3